import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getSemanticSectionsById = (shotclassId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_SEMANTIC_SEARCH_SECTION_BY_ID(shotclassId)
  );
};

export default getSemanticSectionsById;
